import { render, staticRenderFns } from "./EstablishmentYearSettingsTable.vue?vue&type=template&id=707acd46&"
import script from "./EstablishmentYearSettingsTable.vue?vue&type=script&lang=js&"
export * from "./EstablishmentYearSettingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports